import React from 'react';
import { ICountry } from '../../../models/university/IUniversityData';
import styles from './country-pill.module.scss';

type Props = {
  country: ICountry;
  className?: string;
};

export default function CountryPill({ country, className }: Props) {
  return (
    <div
      className={`${styles.pill} country-pill d-flex flex-row ${className ?? ``}`}
      aria-label={`university located in ${country.intoCode}`}
    >
      <img src={country.src} height={15} width={15} alt={country.flagTitle} />
      <p className={`${styles.pill_label} align-items-center`}>{country.intoCode}</p>
    </div>
  );
}
